require('./search.jade')

SearchDirective = ($window, AccountService, $filter, $translate, SelectClubSearchService) ->
  restrict: "A"
  replace: false
  templateUrl: "score-registration/select-club/search.jade"
  scope:
    selectClub: '&onClubSelected'
  link: (scope) ->
    scope.mailTo = ->
      AccountService.getUserInfo().then (user) ->
        email =
          if /^ja/i.test $translate.preferredLanguage()
            'course.i.ja@yourgolf.zendesk.com'
          else
            'course.i.en@yourgolf.zendesk.com'

        subject = $filter('translate')('_SCORE_REGISTRATION.SELECT_CLUB.EMAIL_SUBJECT')
        content = "Account ID: #{user.email} \n
                   UserAgent: #{$window.navigator.userAgent} \n
                   Timestamp: #{new Date()} \n
                   Search Keyword: #{scope.keyword}"
        mailToCode = "mailto:#{email}?subject=#{subject}&body=#{encodeURIComponent(content)}"
        $window.open(mailToCode)

    scope.keyword = undefined
    scope.search = ->
      return if not scope.keyword
      scope.$broadcast "reloadClub.gnp.scoreRegistration"

    scope.loadClub = (page) ->
      SelectClubSearchService.getClubs scope.keyword, page: page

SearchDirective.$inject = ["$window", "AccountService", "$filter", "$translate", "SelectClubSearchService"]

module.exports = SearchDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/select-club/search-directive.coffee